import { Controller } from "@hotwired/stimulus"

//
//== FANCYBOX
import { Fancybox } from "@fancyapps/ui";

export default class extends Controller {
  connect () {
    Fancybox.bind("[data-fancybox]", {
      // The Hash plugin is enabled by default and calls history.back() when
      // closing, so Turbo mistakes it for real back navigation and reacts
      // with a full page revisit (progress bar + scroll-to-top).
      plugins: { Hash: false },
      Toolbar: {
        display: {
          middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
          ],
          right: ["slideshow", "close"],
        },
      }
    })
  }

  disconnect () {
    Fancybox.destroy();
  }
}
